/**
 * @generated SignedSource<<01f1063ad28e654533ff70cf6099f1a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductStatus = "PUBLISHED" | "UN_PUBLISHED";
export type SetStatusProductInput = {
  productID: string;
  status: ProductStatus;
};
export type testPageProductSetStatusMutation$variables = {
  input: SetStatusProductInput;
};
export type testPageProductSetStatusMutation$data = {
  readonly setStatusProduct: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly model: {
      readonly id: string;
      readonly statusID: number;
    } | null;
  };
};
export type testPageProductSetStatusMutation = {
  response: testPageProductSetStatusMutation$data;
  variables: testPageProductSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Model",
  "kind": "LinkedField",
  "name": "model",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "testPageProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73b9a305014425e2c845ffbc858f123b",
    "id": null,
    "metadata": {},
    "name": "testPageProductSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation testPageProductSetStatusMutation(\n  $input: SetStatusProductInput!\n) {\n  setStatusProduct(input: $input) {\n    model {\n      id\n      statusID\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4cab7747b37bd7ee4b0fcb6fe3faaf32";

export default node;
